"use client";

import React, { useState } from "react";
import FooterColumn from "../footerColumn";
import Box from "@sendsprint/ui-react/components/box";
import Typography from "@sendsprint/ui-react/components/typography";
import cs from "classnames";
import Link from "next/link";
import { socialLinks } from "@/layouts/general/data/footerData";
import { Path } from "@/navigations/routes";

const CONTACT_EMAIL = "hi@sendsprint.com";
const CONTACT_PHONES = ["+1 (218) 297-7684", "+1 (888) 296-0772"];

const SocialColumn = () => {
  const [currentHoveredLink, setCurrentHoveredLink] = useState(-1);

  const handleScrollToTop = () => {
    window?.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <FooterColumn
      className="ss:w-2/4 ss:md:w-auto"
      title="Contact"
      key="contact"
    >
      <Link
        className="ss:my-3 ss:text-transparent ss:relative ss:inline-block ss:text-caption ss:md:text-body"
        href={`mailto:${CONTACT_EMAIL}`}
      >
        <Typography
          variant={"paragraphRegular"}
          className="ss:absolute ss:flex ss:justify-center ss:items-center ss:-left-3 ss:-right-3 ss:-top-3 ss:-bottom-3 ss:duration-300 ss:hover:bg-primary1-500 ss:text-neutral-300 ss:hover:text-neutral-50 ss:rounded-lg "
        >
          <span>{CONTACT_EMAIL}</span>
        </Typography>
        {CONTACT_EMAIL}
      </Link>
      <br />
      {CONTACT_PHONES.map((phone) => (
        <React.Fragment key={phone}>
          <Link
            className="ss:my-3 ss:text-transparent ss:relative ss:inline-block ss:text-caption ss:md:text-body"
            href={`tel:${phone}`}
          >
            <Typography
              variant={"paragraphRegular"}
              className="ss:absolute ss:flex ss:justify-center ss:items-center ss:-left-3 ss:-right-3 ss:-top-3 ss:-bottom-3 ss:duration-300 ss:hover:bg-primary1-500 ss:text-neutral-300 ss:hover:text-neutral-50 ss:rounded-lg "
            >
              <span>{phone}</span>
            </Typography>
            {phone}
          </Link>
          <br />
        </React.Fragment>
      ))}
      <Link
        className="ss:my-3 ss:text-transparent ss:relative ss:inline-block ss:text-caption ss:md:text-body"
        href={Path.StateComplaintDisclosures}
        onClick={handleScrollToTop}
        scroll={false}
      >
        <Typography
          variant={"paragraphRegular"}
          className="ss:absolute ss:flex ss:justify-center ss:items-center ss:-left-3 ss:-right-3 ss:-top-3 ss:-bottom-3 ss:duration-300 ss:hover:bg-primary1-500 ss:text-neutral-300 ss:hover:text-neutral-50 ss:rounded-lg "
        >
          <span>State Complaint Disclosures</span>
        </Typography>
        State Complaint Disclosures
      </Link>
      <Box className="">
        {socialLinks.map((link, index) => (
          <a
            target="_blank"
            rel="noreferrer"
            href={link.url}
            key={link.url}
            aria-label={link.name}
            onMouseEnter={() => setCurrentHoveredLink(index)}
            onMouseLeave={() => setCurrentHoveredLink(-1)}
            className=""
          >
            <Box
              key={index}
              className={cs(
                "ss:rounded-full ss:mr-3 ss:mb-3  ss:items-center ss:justify-center ss:inline-flex ss:w-10 ss:md:w-8 ss:h-10 ss:md:h-8",
                {
                  "ss:bg-primary1-300 ss:text-neutral-200":
                    currentHoveredLink !== index,
                  "ss:bg-primary1-400 ss:text-neutral-50":
                    currentHoveredLink === index,
                },
              )}
            >
              {link.icon}
            </Box>
          </a>
        ))}
      </Box>
    </FooterColumn>
  );
};

export default SocialColumn;
